/* eslint-disable @typescript-eslint/no-unused-vars */
import classNames from "classnames";
import { useEnvContext } from "contexts/EnvProvider";
import { useWebStoreContext } from "contexts/WebStoreProvider";
import { FeaturesFlags } from "helpers";
import { useAppSelector } from "hooks";
import { CSSProperties, useMemo } from "react";
import { selectPoisBountyV3State } from "redux/slices";
import { PoisBountyContext } from "./context";
import { getClassNameVariants } from "./helper";
import { useHandlePBLogic, useInitialActions } from "./hooks";
import { PoisBountyContainer } from "./styles";
import { InProgress } from "./variants";

interface PoisBountyWidgetProps {
	isPortrait: boolean;
	isPageVariant?: boolean;
	isClub?: boolean;
	style?: CSSProperties;
}

const PoisBountyWidgetV3 = ({
	isPortrait,
	isPageVariant = false,
	isClub = false,
	style
}: PoisBountyWidgetProps) => {
	const { userTracker } = useWebStoreContext();
	const { isFeatureFlagEnabled } = useEnvContext();
	useInitialActions(isPageVariant);
	useHandlePBLogic(isPageVariant);
	const { tracker, eventActive, variant, allRewardsCollected } = useAppSelector(
		selectPoisBountyV3State
	);

	const showWidget =
		!!userTracker &&
		eventActive &&
		tracker &&
		isFeatureFlagEnabled(FeaturesFlags.POIS_BOUNTY_V2);

	const values = useMemo(
		() => ({ isPortrait, isPageVariant, isClub }),
		[isPortrait, isPageVariant, isClub]
	);

	return showWidget ? (
		<PoisBountyContext.Provider value={values}>
			<PoisBountyContainer
				style={style}
				className={classNames(
					getClassNameVariants(isPageVariant, isPortrait, variant)
				)}
				stepCount={tracker.rewardClaimStatuses.length}
				eventEnded={allRewardsCollected}
				isClub={isClub && !!tracker?.clubMaxPurchasesPerCycle}
			>
				<InProgress />
			</PoisBountyContainer>
		</PoisBountyContext.Provider>
	) : null;
};

export default PoisBountyWidgetV3;
